import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';

interface CategoryFilterProps { selected: string; onSelect: (cat: string) => void; }

const CategoryFilter = ({ selected, onSelect }: CategoryFilterProps) => {
  const { t, i18n } = useTranslation();
  const cls = (active: boolean) => active ? 'category-chip-active' : 'category-chip hover:text-foreground transition-colors cursor-pointer';

  return (
    <div className="flex flex-wrap gap-2">
      <button onClick={() => onSelect('all')} className={cls(selected === 'all')}>{t('markets.allCategories')}</button>
      {categories.map((cat) => (
        <button key={cat.id} onClick={() => onSelect(cat.id)} className={cls(selected === cat.id)}>
          {i18n.language === 'en' ? cat.name_en : cat.name_gr}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
